import HomepageArticle from './HomepageArticle';

export default HomepageArticle;
